var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCabbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3329 7.68001L18.1196 8.25334C19.1596 9.01334 18.6263 10.6667 17.3329 10.6667V12C18.0663 12 18.6663 12.6 18.6663 13.3333C18.6663 14.0667 18.0663 14.6667 17.3329 14.6667V16C18.0663 16 18.6663 16.6 18.6663 17.3333C18.6663 18.0667 18.0663 18.6667 17.3329 18.6667H11.9996V13.3333H7.99961V18.6667H2.66627C1.93294 18.6667 1.33294 18.0667 1.33294 17.3333C1.33294 16.6 1.93294 16 2.66627 16V14.6667C1.93294 14.6667 1.33294 14.0667 1.33294 13.3333C1.33294 12.6 1.93294 12 2.66627 12V10.6667C1.37294 10.6667 0.839606 9.01334 1.87961 8.25334L9.21294 2.92001C9.67961 2.58668 10.3196 2.58668 10.7863 2.92001L14.6663 5.74668V1.33334H17.3329V7.68001ZM3.99961 10.6667V12H15.9996V10.6667H3.99961ZM15.9996 14.6667H13.3329V16H15.9996V14.6667ZM3.99961 14.6667V16H6.66627V14.6667H3.99961ZM9.99961 5.65334L6.77294 8.00001H13.2263L9.99961 5.65334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabbin);
export default __webpack_public_path__ + "static/media/Cabbin.f1d0de33aaba24e2911b6fa8cd3baf65.svg";
export { ForwardRef as ReactComponent };